import React from 'react';
import { bool, func, object, string } from 'prop-types';
import classNames from 'classnames';
// Import util modules
import { FormattedMessage } from '../../../../util/reactIntl';
import { LISTING_STATE_DRAFT } from '../../../../util/types';
// Import shared components
import { H3, ListingLink } from '../../../../components';
// Import modules from this directory
import { showErrorToast } from '../../../../util/toast';
import EditListingLayoutSideNav from '../EditListingLayoutSideNav/EditListingLayoutSideNav';
import EditListingLinksForm from './EditListingLinksForm';

import css from './EditListingLinksPanel.module.css';

const EditListingLinksPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
    config,
    viewport,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const { publicData, state } = listing?.attributes || {};

  const isPublished = listing?.id && state !== LISTING_STATE_DRAFT;

  // Main function to handle form submission
  const handleSubmit = async values => {
    try {
      const { customLinks } = values;
      const updateValues = {
        publicData: {
          customLinks,
        },
      };

      onSubmit(updateValues);
    } catch (error) {
      showErrorToast('Error while submitting details');
    }
  };

  return (
    <div className={classes}>
      <div className={css.contentLayoutWrapper}>
        <EditListingLayoutSideNav listing={listing} />
        <div className={css.detailContent}>
          <H3 as="h1">
            {isPublished ? (
              <FormattedMessage
                id="EditListingLinksPanel.title"
                values={{ listingTitle: <ListingLink listing={listing} />, lineBreak: <br /> }}
              />
            ) : (
              <FormattedMessage
                id="EditListingLinksPanel.createListingTitle"
                values={{ lineBreak: <br /> }}
              />
            )}
          </H3>

          <EditListingLinksForm
            className={css.form}
            initialValues={{ customLinks: publicData.customLinks }}
            saveActionMsg={submitButtonText}
            onSubmit={handleSubmit}
            viewport={viewport}
            disabled={disabled}
            ready={ready}
            listing={listing}
            updated={panelUpdated}
            updateInProgress={updateInProgress}
            fetchErrors={errors}
            config={config}
          />
        </div>
      </div>
    </div>
  );
};

EditListingLinksPanel.defaultProps = {
  className: null,
  rootClassName: null,
  errors: null,
  listing: null,
};

EditListingLinksPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  submitButtonText: string.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingLinksPanel;
